module.exports = __webpack_public_path__ + "static/media/orto.feef67e3.jpg";